"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bosVehicleOrderDraft = exports.bosOrderFragment = void 0;
exports.bosOrderFragment = `
  fragment bosOrder on BosOrder {
    id
    status
    __typename
  }
`;
exports.bosVehicleOrderDraft = `
  fragment bosVehicleOrderDraft on BosVehicleOrderDraft {
    isOrderGenerated
    make
    model
    modelSeries
    quotationNumber
    quoteStatus
    isDraft
    __typename
  }
`;
//# sourceMappingURL=bos-order.js.map